import { createApiClient } from './ApiClient.jsx';

export const createGamificationService = (accessToken) => {
    const api = createApiClient(accessToken);
    
    return {
        async getUserStats(userId) {
            return await api.get(`/api/gamification/stats`);
        },

        async getGamificationSummary(userId) {
            return await api.get(`/api/gamification/summary`);
        },

        async getLeaderboard(limit = 10, userId = null) {
            const params = new URLSearchParams({ limit: limit.toString() });
            return await api.get(`/api/gamification/leaderboard?${params}`);
        },

        async getAchievements(userId) {
            return await api.get(`/api/gamification/achievements`);
        },

        async getTransactionHistory(userId, limit = 20) {
            return await api.get(`/api/gamification/transactions?limit=${limit}`);
        },

        async unlockMinigame() {
            return await api.post(`/api/gamification/unlock_minigame`);
        },

        async unlockAiTutor() {
            return await api.post(`/api/gamification/unlock_ai_tutor`);
        }
    };
};

export const GamificationService = {
    calculateLevel: (xp) => {
        return Math.floor(Math.sqrt(xp / 100)) + 1;
    },

    getXpForLevel: (level) => {
        return Math.pow(level - 1, 2) * 100;
    },

    getLevelProgress: (currentXp, currentLevel) => {
        const currentLevelXp = GamificationService.getXpForLevel(currentLevel);
        const nextLevelXp = GamificationService.getXpForLevel(currentLevel + 1);
        const progressXp = currentXp - currentLevelXp;
        const neededXp = nextLevelXp - currentLevelXp;
        
        return {
            progressXp,
            neededXp,
            percentage: Math.min((progressXp / neededXp) * 100, 100),
            xpToNext: nextLevelXp - currentXp
        };
    },

    getRarityColor: (rarity) => {
        const colors = {
            bronze: 'warning',
            silver: 'info', 
            gold: 'success',
            legendary: 'error'
        };
        return colors[rarity] || 'default';
    }
};
